export default __webpack_public_path__ + "img/master-6ddf4136.png";